import request from '@/utils/request'


// 查询用户金币变动记录列表
export function listCoinRecord(query) {
  return request({
    url: '/user/coinRecord/list',
    method: 'get',
    params: query
  })
}

// 查询用户金币变动记录分页
export function pageCoinRecord(query) {
  return request({
    url: '/user/coinRecord/page',
    method: 'get',
    params: query
  })
}

// 查询用户金币变动记录详细
export function getCoinRecord(data) {
  return request({
    url: '/user/coinRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增用户金币变动记录
export function addCoinRecord(data) {
  return request({
    url: '/user/coinRecord/add',
    method: 'post',
    data: data
  })
}

// 修改用户金币变动记录
export function updateCoinRecord(data) {
  return request({
    url: '/user/coinRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除用户金币变动记录
export function delCoinRecord(data) {
  return request({
    url: '/user/coinRecord/delete',
    method: 'post',
    data: data
  })
}
